export const URL_BASE = 'https://react-rslang.onrender.com'
export const URL_WORDS = `${URL_BASE}/words`
export const URL_USERS = `${URL_BASE}/users`
export const URL_SINGIN = `${URL_BASE}/signin`
export const PAGES_PER_GROUP = 30
export const AMOUNT_VARIANTS_OF_AUDIO_GAMES = 5
export const MAX_MISTAKES_OF_AUDIO_GAMES = 5
export const NUMBER_OF_SECTIONS_IN_TEXTBOOK = 6
